export enum BabaYagaFeatureFlags {
    ZipCodeValidation = 'ZipCodeValidation',
    DrugScreenTestCodesMaxCount = 'DrugScreenTestCodesMaxCount',
    ComplianceInAppNotifications = 'ComplianceInAppNotifications',
    DisableSFTPSterlingStatus = 'DisableSFTPSterlingStatus',
    MentionsFilter = 'MentionsFilter',
    AbilityToMentionUserInLabRequest = 'AbilityToMentionUserInLabRequest',
    SterlingBackgroundChecks = 'SterlingBackgroundChecks',
    LabsEnableSmartyZipCodeValidationForCanada = 'LABS_ENABLE_SMARTY_ZIP_CODE_VALIDATION_FOR_CANADA',
    BackgroundCheckAddAssignTo = 'BackgroundCheckAddAssignTo',
    BgcAddressHistory = 'BgcAddressHistory',
    hdsRefactoring = 'hds-refactoring',
    BackgroundCheckSnoozeUntil = 'BackgroundCheckSnoozeUntil',
    BackgroundCheckShowPackageDetails = 'show-bgc-package-details',
    BackgroundCheckNonSterlingOrders = 'BackgroundCheckNonSterlingOrders',
    HideEmailDetailsNotesOlderThan6Months = 'HideEmailDetailsNotesOlderThan6Months',
    AddPendingInternalDocuments = 'add-pending-internal-documents',
    LabTicketsUseNewComplianceReportEndpoint = 'LabTicketsUseNewComplianceReportEndpoint',
    LabDSCheckbox = 'LabDSCheckbox',
    SterlingAccounts = 'sterling-accounts',
    LabOtherReason = 'LabOtherReason'
}
